module.exports = "query GetLayout($id: ID!) {\n  layout(id: $id) {\n    panel {\n      ...PanelFragment\n    }\n  }\n}\n"